import { net_common } from "@/api/http";
export const API_DisplayDepartmentListReferenceModal = (...params) =>
    net_common.post("/api/STDSDC01C11/DisplayDepartmentListReferenceModal", ...params)

export const API_ChangePrefecture = (...params) =>
net_common.post("/api/STDSDC01C11/ChangePrefecture", ...params)
